export default "__VITE_ASSET__f5fb4894__"